var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.98 31.36",
    style: {
      enableBackground: "new 0 0 31.98 31.36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69770",
    transform: "translate(-2287.814 -265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37309",
    d: "M2313.04,269.47h-1.14v-1.14c0-0.63-0.51-1.14-1.14-1.14s-1.14,0.51-1.14,1.14v1.14h-11.63v-1.14 c0-0.63-0.51-1.14-1.14-1.14s-1.14,0.51-1.14,1.14c0,0,0,0,0,0.01v1.14h-1.14c-2.79,0-5.05,2.26-5.05,5.05v14.59 c0,2.79,2.26,5.05,5.05,5.05h18.47c2.79,0,5.05-2.26,5.05-5.05v-14.59C2318.09,271.73,2315.83,269.47,2313.04,269.47z  M2315.81,289.11c0,1.53-1.24,2.77-2.77,2.77h-18.47c-1.53,0-2.77-1.24-2.77-2.77v-14.59c0-1.53,1.24-2.77,2.77-2.77h1.16 c0.09,0.62,0.66,1.05,1.28,0.97c0.5-0.07,0.89-0.46,0.97-0.97h11.66c0.09,0.62,0.66,1.05,1.28,0.97c0.5-0.07,0.89-0.46,0.97-0.97 h1.16c1.53,0,2.77,1.24,2.77,2.77L2315.81,289.11L2315.81,289.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37310",
    d: "M2305.21,285.83h-2.83c-0.63,0-1.14,0.51-1.14,1.14s0.51,1.14,1.14,1.14h2.83 c0.63,0,1.14-0.51,1.14-1.14S2305.84,285.83,2305.21,285.83L2305.21,285.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37311",
    d: "M2305.21,275.4h-2.83c-0.63,0-1.14,0.51-1.14,1.14s0.51,1.14,1.14,1.14c0,0,0,0,0.01,0h2.83 c0.63,0,1.14-0.51,1.14-1.14C2306.35,275.91,2305.84,275.4,2305.21,275.4L2305.21,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37312",
    d: "M2305.21,280.61h-2.83c-0.63,0-1.14,0.51-1.14,1.14s0.51,1.14,1.14,1.14h2.83 c0.63,0,1.14-0.51,1.14-1.14S2305.84,280.61,2305.21,280.61L2305.21,280.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37313",
    d: "M2298.53,285.62h-2.83c-0.63,0-1.14,0.51-1.14,1.14s0.51,1.14,1.14,1.14h2.83 c0.63,0,1.14-0.51,1.14-1.14S2299.16,285.62,2298.53,285.62L2298.53,285.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37314",
    d: "M2298.53,280.4h-2.83c-0.63,0-1.14,0.51-1.14,1.14s0.51,1.14,1.14,1.14h2.83 c0.63,0,1.14-0.51,1.14-1.14S2299.16,280.4,2298.53,280.4L2298.53,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37315",
    d: "M2311.9,285.83h-2.83c-0.63,0-1.14,0.51-1.14,1.14s0.51,1.14,1.14,1.14h2.83 c0.63,0,1.14-0.51,1.14-1.14C2313.04,286.34,2312.53,285.83,2311.9,285.83L2311.9,285.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37316",
    d: "M2311.9,275.4h-2.83c-0.63,0-1.14,0.51-1.14,1.14s0.51,1.14,1.14,1.14h2.83 c0.63,0,1.14-0.51,1.14-1.14C2313.03,275.91,2312.52,275.4,2311.9,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37317",
    d: "M2311.9,280.61h-2.83c-0.63,0-1.14,0.51-1.14,1.14s0.51,1.14,1.14,1.14h2.83 c0.63,0,1.14-0.51,1.14-1.14S2312.53,280.61,2311.9,280.61L2311.9,280.61z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.401f70da73e9457ea904bb74f3fd6f41.svg";
export { ForwardRef as ReactComponent };